import React, { useEffect, useRef, useState } from 'react';
import {
    Box,
    Button,
    Grid,
    TextField,
    Typography,
    FormControlLabel,
    Switch,
    Avatar,
    SelectChangeEvent,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    CircularProgress,
    Backdrop,
    Stack,
    IconButton,
    ButtonBase,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    DialogContentText
} from '@mui/material';
import RELogo from '../../../../../Assets/AuthBackGround/RecEzyLogo.png';
import { theme } from '../../../../../theme';
import { useNavigate } from 'react-router-dom';
import { useLocation, useParams } from 'react-router-dom';
import CustomFields from '../CustomFields/CustomFields';
import ReactQuill from 'react-quill';
import { apiUrl } from '../../../../../Constant/apiConstant';
import { postJsonRequest } from '../../../../../service/apiService';
import { deleteJobLogo, getFormDropdowns, getGeneratedJobPostingId, getHiringFlow, getJobDetails, getJobFields, postMarketJobData, uploadJobLogo } from '../../jobManagemnetApi';
import { removeSpacing, sanitizeContent } from '../../../../Common/Sanitize/sanitizeReactQuill';
import HiringFlowDropdown from './HiringFlowDropdown';
import { useSnackbar } from '../../../../../Context/SnackbarContext';
import ReadJob from './ReadJob';
import PriorityBadge from './PriorityBadge';
import LocationAutocomplete from './LocationAutocomplete';
import EkoAssistDialog from './EkoAssistPopup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';


export interface IFieldData {
    fieldKey: number;
    fieldName: string;
    values: string[];
}

export interface HiringFlowDropdownType {
    StepNum: number;
    StepName: string
}

interface setJobNumProp {
    setJobNum: (jobNum: number) => void;
    setMarketJobTitle: (jobTitle: string) => void;
    setReadOnly: (value: boolean) => void;
    setJobLocation: (value: string) => void;
}

export interface ExtraJobFieldsType {
    noOfOpenings: null | number,
    hiringStartDate: string;
    hiringEndDate: string;
    currencyType: string;
    salaryStartRanage: null | number;
    salaryEndRange: null | number;
    jobType: string;
    location: string;
    toExperience: string | null;
    priority: string;
    fromExperience: string | null;
}

export interface CurrencyDropdownType {
    id: number,
    Country: string,
    CurrencyCode: string,
    CurrencySymbol: string,
    Locale: string
}

export interface JobTypeDropdownType {
    JobTypeId: number,
    JobTypeKey: string
}

export interface JobPriorityDropdownType {
    JobPriorityId: number,
    JobPriorityKey: string
}

const MAX_FILE_SIZE = 50 * 1024; // 50 KB
const ALLOWED_TYPES = ['image/png', 'image/jpeg', 'image/jpg', 'image/svg+xml'];

const CreateJob: React.FC<setJobNumProp> = ({ setJobNum, setMarketJobTitle, setReadOnly, setJobLocation }) => {
    const navigate = useNavigate()
    const { tenant } = useParams<{ tenant: string }>();
    const location = useLocation();
    const { jobNum, ReadOnly } = location.state || {};
    const [jobSector, setJobSector] = useState('')
    const [jobTitle, setJobTitle] = useState('')
    const [jobDescription, setJobDescription] = useState('')
    const [errors, setErrors] = useState<{ [key: string]: string }>({})
    const [newFieldsData, setNewFieldsData] = useState<IFieldData[]>([]);
    const [showNewFieldContainer, setShowNewFieldContainer] = useState(
        !!newFieldsData.length,
    );
    const [internalJob, setInternalJob] = useState<boolean>(false);
    const [initialValues, setInitialValues] = useState({
        jobSector: '',
        jobTitle: '',
        jobStatus: '',
        jobDescription: '',
        internalJob: false,
        fields: [] as IFieldData[],  // Store initial custom fields data
    });
    const [jobStatus, setJobStatus] = useState<string>('')
    const [loading, setLoading] = useState(false)
    const [disableSaveJoblisting, setDisableSaveJoblisting] = useState(false)
    const [currentStep, setCurrentStep] = useState(1);
    const [hiringFlow, setHiringFlow] = useState<string[]>([]);
    const [stages, setStages] = useState<HiringFlowDropdownType[]>([])
    const [hiringFlowEditMode, setHiringFlowEditMode] = useState(false); // initially editable
    const [showEditHiringFlow, setShowEditHiringFlow] = useState(true); // initially not shown
    const [extraJobFields, setExtraJobFields] = useState<ExtraJobFieldsType>({
        noOfOpenings: null,
        hiringStartDate: '',
        hiringEndDate: '',
        currencyType: '',
        salaryStartRanage: null,
        salaryEndRange: null,
        jobType: '',
        location: '',
        toExperience: null,
        fromExperience: null,
        priority: ''
    })
    const { showSnackbar } = useSnackbar();
    const [generatedJobID, setGeneratedJobID] = useState('');
    const [currencyDropdown, setCurrencydropdown] = useState<CurrencyDropdownType[]>([])
    const [jobTypeDropdown, setJobTypeDropdown] = useState<JobTypeDropdownType[]>([])
    const [jobPriorityDropdown, setJobProiorityDropdown] = useState<JobPriorityDropdownType[]>([])
    const [hirigFlowData, setHiringFlowData] = useState<any>()
    const [isEkoOpen, setIsekoOpen] = useState(false);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false); // For delete confirmation dialog
    const [logoFile, setLogoFile] = useState<File | null>(null);
    const [fileName, setFileName] = useState('')
    const [error, setError] = useState<string | null>(null);
    const [locale, setLocale] = useState<string>("en-US"); // default fallback


    const handleOpen = () => setIsekoOpen(true);
    const handleClose = () => {
        setIsekoOpen(false);
    };


    const fetchFormDropdowns = async () => {
        const result = await getFormDropdowns(tenant)
        if (result) {
            setCurrencydropdown(result.Currencies)
            setJobTypeDropdown(result.JobTypes)
            setJobProiorityDropdown(result.JobPriorities)
        }
    }

    const formatNumber = (num: any, locale: any) => {
        return new Intl.NumberFormat(locale).format(num);
    };


    const handleFile = (file: File) => {
        if (!ALLOWED_TYPES.includes(file.type)) {
            setError('Only PNG, JPG, JPEG, SVG files are allowed.');
            return;
        }

        if (file.size > MAX_FILE_SIZE) {
            setError('File size must be under 50KB.');
            return;
        }
        console.log(file)

        setError(null);
        setLogoFile(file);
        setFileName(file.name)
        // Upload logic here
    };

    const handleDrop = (e: React.DragEvent) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        if (file) handleFile(file);
    };

    const handleFileSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (file) handleFile(file);
    };

    const handleDeleteLogo = () => {
        if (logoFile && fileName) {
            // Logo is only in UI, not saved to DB
            setLogoFile(null);
            setFileName('');
            setError(null);
        } else {
            // Logo is saved in DB, show confirmation dialog
            setDeleteDialogOpen(true);
        }
    }


    const validateFields = () => {
        const newErrors: { [key: string]: string } = {};
        const { currencyType, salaryStartRanage, salaryEndRange } = extraJobFields;

        // Check if any one of the salary fields is filled
        const isAnySalaryFieldFilled = currencyType || salaryStartRanage || salaryEndRange;

        if (currentStep === 1) {
            // Step 1 validations: job title, department, description
            if (!jobSector.trim()) {
                newErrors.jobsector = 'Department is required.';
            }

            if (!jobTitle.trim()) {
                newErrors.jobtitle = 'Job title is required.';
            }

            const sanitizedValue = sanitizeContent(jobDescription);
            if (!sanitizedValue) {
                newErrors.jobdescription = 'Job description is required.';
            }

        } else if (currentStep === 2) {
            // Step 2 validations: all fields in extraJobFields
            if (!extraJobFields.noOfOpenings) {
                newErrors.noOfOpenings = 'Number of openings is required.';
            }

            if (!extraJobFields.hiringStartDate) {
                newErrors.hiringStartDate = 'Hiring start date is required.';
            }

            if (!extraJobFields.hiringEndDate) {
                newErrors.hiringEndDate = 'Hiring end date is required.';
            }

            if (isAnySalaryFieldFilled) {
                if (!currencyType) {
                    newErrors.currencyType = 'Currency type is required.';
                }
                if (!salaryStartRanage) {
                    newErrors.salaryStartRanage = 'Starting salary is required.';
                }
                if (!salaryEndRange) {
                    newErrors.salaryEndRange = 'Ending salary is required.';
                }

                // ✅ Range validation
                if (
                    salaryStartRanage !== null &&
                    salaryEndRange !== null &&
                    salaryStartRanage > salaryEndRange
                ) {
                    // newErrors.salaryStartRanage = 'Starting salary should be less than ending salary.';
                    newErrors.salaryEndRange = 'Ending salary should be greater than starting salary.';
                }
            }

            if (!extraJobFields.jobType) {
                newErrors.jobType = 'Job type is required.';
            }

            if (!extraJobFields.location.trim()) {
                newErrors.location = 'Location is required.';
            }

            if (extraJobFields.fromExperience === null || extraJobFields.fromExperience === '') {
                newErrors.fromExperience = 'Min experience is required.';
            }

            // if (extraJobFields.toExperience === null || extraJobFields.toExperience === '') {
            //     newErrors.toExperience = 'Max experience is required.';
            // }

            if (
                extraJobFields.fromExperience !== null &&
                extraJobFields.fromExperience !== '' &&
                extraJobFields.toExperience !== null &&
                extraJobFields.toExperience !== ''
            ) {
                const minExp = Number(extraJobFields.fromExperience);
                const maxExp = Number(extraJobFields.toExperience);
                if (minExp === maxExp) {
                    newErrors.toExperience = 'Min and Max experience cannot be the same.';
                }
                if (minExp > maxExp) {
                    newErrors.toExperience = 'Max experience should be greater than min experience.';
                }
            }

            if (!extraJobFields.priority) {
                newErrors.priority = 'Priority is required.';
            }
            if (!hiringFlow.length) {
                newErrors.hiringFlow = 'Hiring flow is required.';
            }

        }

        // Return true if errors exist (prevent navigation)
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            showSnackbar("Please fill all required fields.", "error")
            return true;
        }

        return false;
    };





    const modules = {

        toolbar: [
            [{ 'header': [] }],
            ['bold', 'italic', 'underline', 'link'],
            [{ 'list': 'bullet' }, { 'list': 'ordered' }],
        ],
        clipboard: {
            matchVisual: false, // Prevents Quill from auto-converting visual line breaks to `<p><br></p>`
        },
    };
    const handleJobListing = () => {
        navigate(`/${tenant}/Joblisting`)
    }

    const fetchHiringFlow = async () => {
        const result = await getHiringFlow(tenant)
        setStages(result)
    }
    const fetchGeneratedJobPostingID = async () => {
        const result = await getGeneratedJobPostingId(tenant, jobNum)
        if (result) {
            setGeneratedJobID(result)
        }
    };

    const fetchJobData = async () => {
        try {
            const response = await getJobDetails(tenant, jobNum)

            if (response) {
                const jobData = response.JobData;
                const ExtraFields = response.ExtraFields;
                setMarketJobTitle(jobData.JobTitle)
                setJobTitle(jobData.JobTitle);
                setJobSector(jobData.Department);
                setJobDescription(jobData.JobDescr);
                setInternalJob(jobData.InternalJob)
                setJobStatus(jobData.Status)
                if (jobData.JobPostingId) {
                    setGeneratedJobID(jobData.JobPostingId);
                }
                else {
                    await fetchGeneratedJobPostingID()
                }

                if (ExtraFields) {
                    setExtraJobFields((prev) => ({
                        ...prev,
                        noOfOpenings: ExtraFields.NoOfOpenings || null,
                        hiringStartDate: ExtraFields.HiringStartDate.split(" ")[0] || '',
                        hiringEndDate: ExtraFields.HiringEndDate.split(" ")[0] || '',
                        currencyType: ExtraFields.CurrencyCode || '',
                        salaryStartRanage: ExtraFields.SalaryFrom || null,
                        salaryEndRange: ExtraFields.SalaryTo || null,
                        jobType: ExtraFields.JobTypeId || '',
                        location: ExtraFields.JobLocation || '',
                        fromExperience: ExtraFields.FromExperience?.toString() || null,
                        toExperience: ExtraFields.ToExperience?.toString() || null,
                        priority: ExtraFields.JobPriorityId || ''
                    }))
                    setJobLocation(ExtraFields.JobLocation)
                    setHiringFlowData(ExtraFields.HiringFlow || [])
                    setShowEditHiringFlow(ExtraFields.IsHiringFlowEditable)
                }
                if (response.Logo) {
                    setFileName(response.Logo)
                }


                setInitialValues({
                    jobSector: jobData.Department || '',
                    jobTitle: jobData.JobTitle || '',
                    jobStatus: jobData.Status || '',
                    jobDescription: jobData.JobDescr || '',
                    internalJob: jobData.InternalJob || false,
                    fields: jobData.fields || [],
                });
                // Initialize other fields if required
                const fieldResponse = await getJobFields(tenant, jobNum)
                if (fieldResponse) {
                    const fetchedFields = fieldResponse.map((field: any, index: number) => ({
                        fieldKey: index + 1,
                        fieldName: field.FieldName,
                        values: field.FieldValue ? field.FieldValue.split(',') : [],
                    }));
                    setNewFieldsData(fetchedFields);
                    setShowNewFieldContainer(!!fetchedFields.length)
                    setInitialValues((prev) => ({ ...prev, fields: fetchedFields }));
                }
            }
        } catch (error) {
            console.error('Error fetching job data:', error);
        }
    };


    useEffect(() => {
        if (!jobNum) {
            fetchGeneratedJobPostingID()
            fetchFormDropdowns()
            fetchHiringFlow()
            setHiringFlowEditMode(true)
        }
    }, [tenant])

    useEffect(() => {
        if (extraJobFields.currencyType) {
            const selectedCurrency = currencyDropdown.find(
                (opt) => opt.CurrencyCode === extraJobFields.currencyType
            );
            if (selectedCurrency?.Locale) {
                setLocale(selectedCurrency.Locale);
            }
        }
    }, [extraJobFields.currencyType, currencyDropdown]);


    useEffect(() => {
        if (jobNum) {
            setJobNum(jobNum)
            setReadOnly(ReadOnly || false)
            fetchFormDropdowns()
            fetchJobData();
            fetchHiringFlow()
        }
    }, [jobNum]);


    const hasChanges = () => {
        // If no JobNum, assume it's a new job creation and always return true for non-empty fields
        if (!jobNum) {
            return true
        }
        // Check if main fields have changed
        if (
            initialValues.jobSector !== jobSector ||
            initialValues.jobTitle !== jobTitle ||
            initialValues.jobDescription !== jobDescription ||
            initialValues.internalJob !== internalJob ||
            initialValues.jobStatus !== jobStatus
        ) {
            return true;
        }

        // Check if custom fields have changed
        if (initialValues.fields.length !== newFieldsData.length) return true;
        for (let i = 0; i < newFieldsData.length; i++) {
            if (
                initialValues.fields[i].fieldName !== newFieldsData[i].fieldName ||
                JSON.stringify(initialValues.fields[i].values) !== JSON.stringify(newFieldsData[i].values)
            ) {
                return true;
            }
        }

        return false;
    };

    const confirmDeleteLogo = async () => {
        try {
            const result = await deleteJobLogo(tenant, { JobNum: jobNum })
            if (result) {
                showSnackbar("Logo deleted successfully.", "success")
                setFileName('')
            } else {
                showSnackbar("Failed to delete logo.", "error")
            }
        } catch (error) {
            console.log(error)
        } finally {
            setDeleteDialogOpen(false)
        }

    }


    const handleSaveJob = async () => {
        // if (!hasChanges()) {
        //     navigate(`/${tenant}/Joblisting`)
        //     return;
        // }

        if (validateFields()) {
            return
        }


        // ✅ Check for "skill" field presence
        // const hasSkillField = newFieldsData.some(field =>
        //     field.fieldName?.toLowerCase().includes("skill")
        // );

        // if (!hasSkillField) {
        //     newErrors.customfields = 'Please include a custom field for skills.';
        // }

        const currency = currencyDropdown.find((c) => {
            return c.CurrencyCode === extraJobFields.currencyType;
        });

        const description = removeSpacing(jobDescription)

        const addPayLoad = {
            JobTitle: jobTitle,
            Department: jobSector,
            JobStatus: jobStatus,
            JobDescr: description,
            Fields: newFieldsData,
            InternalJob: internalJob,
            JobPostingId: generatedJobID,
            NoOfOpenings: extraJobFields.noOfOpenings,
            HiringStartDate: extraJobFields.hiringStartDate,
            HiringEndDate: extraJobFields.hiringEndDate,
            CurrencyID: currency?.id || null,
            SalaryFrom: extraJobFields.salaryStartRanage,
            SalaryTo: extraJobFields.salaryEndRange,
            JobTypeID: extraJobFields.jobType,
            JobLocation: extraJobFields.location,
            JobPriorityId: extraJobFields.priority,
            ToExperience: Number(extraJobFields.toExperience),
            FromExperience: Number(extraJobFields.fromExperience),
            HiringFlow: hiringFlow
        }

        const editPaylod = {
            JobNum: jobNum,
            JobTitle: jobTitle,
            Department: jobSector,
            JobStatus: jobStatus,
            JobDescr: description,
            Fields: newFieldsData,
            InternalJob: internalJob,
            JobPostingId: generatedJobID,
            NoOfOpenings: extraJobFields.noOfOpenings,
            HiringStartDate: extraJobFields.hiringStartDate,
            HiringEndDate: extraJobFields.hiringEndDate,
            CurrencyID: currency?.id || null,
            SalaryFrom: extraJobFields.salaryStartRanage,
            SalaryTo: extraJobFields.salaryEndRange,
            JobTypeID: extraJobFields.jobType,
            JobLocation: extraJobFields.location,
            JobPriorityId: extraJobFields.priority,
            ToExperience: Number(extraJobFields.toExperience),
            FromExperience: Number(extraJobFields.fromExperience),
            HiringFlow: hiringFlow
        }
        const payLoad = jobNum ? editPaylod : addPayLoad

        try {
            const Url = jobNum
                ? apiUrl.JM_POST_EDIT_JOB  // Update if editing
                : apiUrl.JM_POST_ADD_JOB;  // Add if creating 

            const response = await postJsonRequest(Url, payLoad, tenant)
            if (response.status === 200 || response.status === 201) {
                showSnackbar(jobNum ? 'Job updated successfully.' : 'Job created successfully.', 'success');
                navigate(`/${tenant}/Joblisting`)

                // Only call runPostMarketJobData if the job was created, not edited

                await uploadJobLogo(tenant, response.data.JobNum || jobNum, logoFile)


                if (!jobNum) {
                    await postMarketJobData(tenant, jobTitle, response.data.JobNum, extraJobFields.location);
                }

            }

        } catch (error) {
            console.log(error)
        }


    }



    const handleAddMoreField = (e: React.FormEvent) => {
        if (!showNewFieldContainer) setShowNewFieldContainer(true);
        const initFieldData: IFieldData = {
            fieldKey: newFieldsData.length + 1,
            fieldName: '',
            values: [],
        };
        setNewFieldsData([...newFieldsData, initFieldData]);
    };

    const onFieldDataUpdate = (newData: IFieldData) => {
        const updatedFieldsData = newFieldsData.map((data) =>
            data.fieldKey === newData.fieldKey ? newData : data,
        );
        setNewFieldsData(updatedFieldsData);
    };

    const onDeleteField = (deleteKey: number) => {
        const updatedFieldsData = newFieldsData.filter(
            (data) => data.fieldKey !== deleteKey,
        );
        setNewFieldsData(updatedFieldsData);
    };

    // Types
    type ExtraJobFieldKeys = keyof ExtraJobFieldsType;
    type MainJobFields = "jobtitle" | "jobsector" | "jobdescription";
    type AllFieldKeys = MainJobFields | ExtraJobFieldKeys;


    const handleInputChange = (value: string, field: AllFieldKeys) => {
        // Reset error for the field
        setErrors((prev) => ({
            ...prev,
            [field]: "",
        }));

        // Handle main job fields
        if (field === "jobtitle") setJobTitle(value);
        else if (field === "jobsector") setJobSector(value);
        else if (field === "jobdescription") setJobDescription(value);

        // Handle extra job fields
        else {
            let parsedValue: any = value;

            // Handle numeric cleaning for salary fields
            if (["salaryStartRanage", "salaryEndRange"].includes(field)) {
                const numeric = value.replace(/[^\d]/g, '');
                parsedValue = numeric ? parseInt(numeric, 10) : null;
            }

            // If currencyType is being updated, also update the locale
            // if (field === "currencyType") {
            //     const selectedCurrency = currencyDropdown.find(opt => opt.CurrencyCode === value);
            //     setLocale(selectedCurrency?.Locale || "en-US");
            // }

            // Parse other numeric fields
            if (field === "noOfOpenings") {
                parsedValue = value === "" ? null : Number(value);
            }

            setExtraJobFields((prev) => ({
                ...prev,
                [field]: parsedValue,
            }));
        }
    };




    const handleNext = () => {
        if (validateFields()) {
            showSnackbar('Please save the current page data before proceeding to the next.', 'error');
            return
        }
        setCurrentStep(2)
    }




    if (ReadOnly) {
        return (
            <ReadJob
                jobTitle={jobTitle}
                jobSector={jobSector}
                jobStatus={jobStatus}
                jobDescription={jobDescription}
                newFieldsData={newFieldsData}
                jobPostingId={generatedJobID}
                extraJobFields={extraJobFields}
                currencyDropdown={currencyDropdown}
                jobTypeDropdown={jobTypeDropdown}
                jobPriorityDropdown={jobPriorityDropdown}
                hirigFlowData={hirigFlowData}
                handleJobListing={handleJobListing}
            />
        )
    }
    return (
        <Box mb={7} >
            <Typography variant="h5" >
                {jobNum ? 'Edit Job Posting' : 'Post a New Job'}
            </Typography>
            <Typography variant="subtitle1" mb='1.6667vw'>
                {jobNum ? 'Update your Job Posting Details' : 'Customize the Perfect Job Post'}
            </Typography>
            <Box display="flex"
                flexDirection="column"
                sx={{ minHeight: '100%', width: '100%' }}>


                <Box flexGrow={1}
                    sx={{
                        p: 3,
                        border: 1,
                        borderColor: 'divider',
                        overflow: 'visible',
                        borderTopLeftRadius: '1vw',
                        borderTopRightRadius: '1vw'
                    }}>
                    {
                        currentStep === 1 && (
                            <>
                                <Grid container spacing={2} mb={"1.6667vw"}>
                                    <Grid item xs={jobNum ? 3 : 4} sx={{ display: 'flex', alignItems: 'center' }}>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            label="Job Posting ID"
                                            value={generatedJobID}
                                            required
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            sx={{
                                                '& .MuiInputBase-input.Mui-disabled': {
                                                    WebkitTextFillColor: '#6e6e6e',
                                                },
                                                '& .MuiInputBase-input': {
                                                    color: '#6e6e6e',      // text color
                                                    backgroundColor: '#f5f5f5', // grey background
                                                    cursor: 'not-allowed',
                                                },
                                            }}
                                        />

                                        {/* <Typography variant="body2"><strong>Job Posting ID: </strong>{generatedJobID}</Typography> */}
                                    </Grid>
                                    <Grid item xs={jobNum ? 3 : 4}>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            label="Job Title"
                                            value={jobTitle}
                                            onChange={(e) => handleInputChange(e.target.value, "jobtitle")}
                                            error={!!errors.jobtitle}
                                            helperText={errors.jobtitle}
                                            required
                                            autoComplete='off' />
                                    </Grid>
                                    <Grid item xs={jobNum ? 3 : 4}>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            label="Department"
                                            value={jobSector}
                                            onChange={(e) => handleInputChange(e.target.value, "jobsector")}
                                            error={!!errors.jobsector}
                                            helperText={errors.jobsector}
                                            required
                                            autoComplete='off' />
                                    </Grid>
                                    {jobNum ? (
                                        <Grid item xs={jobNum ? 3 : 4}>
                                            <FormControl fullWidth size="small" required>
                                                <InputLabel>Job Status</InputLabel>
                                                <Select value={jobStatus} label="Job Status" onChange={(e) => setJobStatus(e.target.value)} >
                                                    <MenuItem value="Open">Open</MenuItem>
                                                    <MenuItem value="Close">Close</MenuItem>
                                                    <MenuItem value="On-hold">On-hold</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    ) : (<></>)}
                                </Grid>

                                {/* Replace the current TextField with ReactQuill for Description */}
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Typography variant="body2" mt={2}>
                                        Description <span style={{ color: theme.palette.error.main }}>* </span>
                                    </Typography>
                                    <ButtonBase
                                        onClick={handleOpen}
                                        sx={{
                                            mt: 1,
                                            ml: 2,
                                            px: 1.5,
                                            py: 0.75,
                                            mb: 1,
                                            borderRadius: 1,
                                            border: `1.5px solid ${theme.palette.primary.main}`,
                                            display: "flex",
                                            alignItems: "center",
                                            width: '10vw',
                                            height: '2.5vw',
                                        }}
                                        title='Your AI assistant for crafting precise and tailored job descriptions.'
                                    >
                                        <Avatar
                                            src={RELogo}
                                            sx={{ width: '1.8vw', height: '1.8vw', mr: 1 }}
                                        />
                                        <Typography variant="body2" fontWeight={900} color={theme.palette.primary.main}>
                                            Eko Assist
                                        </Typography>
                                    </ButtonBase>
                                </Box>


                                <Box sx={{ display: 'flex', flexDirection: 'column', marginBottom: '1.66vw' }}>
                                    <ReactQuill
                                        value={jobDescription}
                                        onChange={(value) => handleInputChange(value, "jobdescription")}
                                        modules={modules}
                                        style={{ height: '30vh', marginBottom: '2vh' }} // Set your desired height here
                                    />
                                    {errors.jobdescription && <Typography variant='body1' sx={{ color: theme.palette.error.main, mt: 3.5, ml: 1.5 }}>{errors.jobdescription}</Typography>}
                                </Box>


                                <Grid container spacing={1} alignItems="center" mt={0.5}>
                                    <Grid item xs={12}>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                bgcolor: 'white',
                                                p: '0.15vw',
                                                my: '1.1vw',
                                                borderRadius: '0.55vw',
                                                cursor: 'pointer',
                                                minHeight: '12vh',
                                                justifyContent: 'space-between',
                                            }}
                                            onDrop={handleDrop}
                                            onDragOver={(e) => e.preventDefault()}
                                        >
                                            <Avatar
                                                src={RELogo}
                                                sx={{ ml: 2, width: '3vw', height: '3vw' }}
                                            />

                                            {fileName ? (
                                                <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', px: 2 }}>
                                                    <Typography sx={{ flex: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                        {fileName}
                                                    </Typography>
                                                    <IconButton
                                                        onClick={handleDeleteLogo}
                                                        sx={{ color: theme.palette.primary.main, ml: 1 }}
                                                    >
                                                        <i className="fa-solid fa-trash fa-xs"></i>
                                                    </IconButton>
                                                </Box>
                                            ) : (
                                                <Button
                                                    component="label"
                                                    variant="outlined"
                                                    sx={{
                                                        flex: 1,
                                                        textAlign: 'center',
                                                        p: '1.38vw 0',
                                                        mx: 2,
                                                        borderRadius: '0.55vw',
                                                        border: '0.069vw solid #ccc',
                                                    }}
                                                >
                                                    <Box>
                                                        <i className="fa-solid fa-cloud-arrow-up fa-xl" style={{ color: '#7F56D9' }} />
                                                        <Typography variant="body1" sx={{ color: '#7F56D9' }}>
                                                            Upload Logo
                                                        </Typography>
                                                        <Typography variant="body2" sx={{ color: '#565656' }}>
                                                            or drag and drop
                                                        </Typography>
                                                        <Typography variant="body2" sx={{ color: '#565656' }}>
                                                            PNG, JPG, SVG (max 50KB)
                                                        </Typography>
                                                    </Box>
                                                    <input hidden type="file" accept="image/*" onChange={handleFileSelect} />
                                                </Button>
                                            )}
                                        </Box>

                                        {error && (
                                            <Typography variant="body2" color="error" mt={1} textAlign="center">
                                                {error}
                                            </Typography>
                                        )}
                                    </Grid>
                                </Grid>

                            </>
                        )
                    }

                    {currentStep === 2 && (
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>

                            <TextField
                                label="Number of Openings"
                                value={extraJobFields.noOfOpenings ?? ''}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const regex = /^[0-9]*$/; // Allow digits and backspace
                                    if (regex.test(value)) {
                                        handleInputChange(e.target.value, "noOfOpenings");
                                    }
                                }}
                                sx={{ width: '25vw' }}
                                size="small"
                                required
                                error={!!errors.noOfOpenings}
                                helperText={errors.noOfOpenings}
                                autoComplete='off'
                            />

                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                                <Typography
                                    variant="body3"
                                >
                                    Hiring Period <span style={{ color: theme.palette.error.main }}>* </span>
                                </Typography>
                                <Box sx={{ display: 'flex', gap: 3 }}>
                                    <TextField
                                        type="date"
                                        label="Start Date"
                                        value={extraJobFields.hiringStartDate || ''}
                                        onChange={(e) => handleInputChange(e.target.value, "hiringStartDate")}
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{
                                            min: new Date().toISOString().split('T')[0],
                                            max: extraJobFields.hiringEndDate || undefined,
                                        }}
                                        size="small"
                                        sx={{
                                            width: '20vw',
                                            '& input': {
                                                color: 'rgba(0, 0, 0, 0.6)', // <- grey color (same as placeholder)
                                            },
                                        }}
                                        error={!!errors.hiringStartDate}
                                        helperText={errors.hiringStartDate}
                                        autoComplete='off'
                                    />

                                    <TextField
                                        type="date"
                                        label="End Date"
                                        value={extraJobFields.hiringEndDate || ''}
                                        onChange={(e) => handleInputChange(e.target.value, "hiringEndDate")}
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{
                                            min: extraJobFields.hiringStartDate || new Date().toISOString().split('T')[0],
                                        }}
                                        size="small"
                                        sx={{
                                            width: '20vw',
                                            '& input': {
                                                color: 'rgba(0, 0, 0, 0.6)', // <- match grey color
                                            },
                                        }}
                                        error={!!errors.hiringEndDate}
                                        helperText={errors.hiringEndDate}
                                        autoComplete='off'
                                    />


                                </Box>
                            </Box>


                            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>

                                {/* Salary Range Fields */}
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.8 }}>
                                    <Typography variant="body2">Salary Range</Typography>
                                    <Box sx={{ display: 'flex', gap: 2 }}>
                                        {/* Salary From */}
                                        <TextField
                                            label="From"
                                            value={
                                                extraJobFields.salaryStartRanage !== null && extraJobFields.salaryStartRanage !== undefined
                                                    ? formatNumber(extraJobFields.salaryStartRanage, locale)
                                                    : ''
                                            }
                                            onChange={(e) => handleInputChange(e.target.value, "salaryStartRanage")}
                                            size="small"
                                            sx={{ width: '20vw' }}
                                            error={!!errors.salaryStartRanage}
                                            helperText={errors.salaryStartRanage}
                                            autoComplete='off'
                                        />

                                        {/* Salary To */}
                                        <TextField
                                            label="To"
                                            value={
                                                extraJobFields.salaryEndRange !== null && extraJobFields.salaryEndRange !== undefined
                                                    ? formatNumber(extraJobFields.salaryEndRange, locale)
                                                    : ''
                                            }
                                            onChange={(e) => handleInputChange(e.target.value, "salaryEndRange")}
                                            size="small"
                                            sx={{ width: '20vw' }}
                                            error={!!errors.salaryEndRange}
                                            helperText={errors.salaryEndRange}
                                            autoComplete='off'
                                        />

                                    </Box>
                                </Box>

                                {/* Currency Dropdown */}
                                <TextField
                                    select
                                    label="Currency Type"
                                    value={extraJobFields.currencyType}
                                    onChange={(e) => handleInputChange(e.target.value, "currencyType")}
                                    size="small"
                                    fullWidth
                                    sx={{ width: '20vw', mt: 2.5 }}
                                    error={!!errors.currencyType}
                                    helperText={errors.currencyType}
                                    SelectProps={{
                                        renderValue: (value) => {
                                            const selected = value as string;
                                            const selectedOption = currencyDropdown.find(opt => opt.CurrencyCode === selected);
                                            return selectedOption ? (
                                                <Box display="flex" justifyContent="space-between" width="100%">
                                                    <span>{selectedOption.CurrencySymbol}</span>
                                                    <span>{selectedOption.Country}</span>
                                                </Box>
                                            ) : selected;
                                        },
                                    }}
                                    autoComplete='off'
                                >
                                    {currencyDropdown.map((option) => (
                                        <MenuItem key={option.CurrencyCode} value={option.CurrencyCode}>
                                            {option.Country} ({option.CurrencySymbol})
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Box>


                            <TextField
                                select
                                label="Job Type"
                                value={extraJobFields.jobType}
                                onChange={(e) => handleInputChange(e.target.value, "jobType")}
                                size="small"
                                required
                                sx={{ width: '30vw' }}
                                error={!!errors.jobType}
                                helperText={errors.jobType}
                                autoComplete='off'
                            >
                                {jobTypeDropdown.map((option) => (
                                    <MenuItem key={option.JobTypeId} value={option.JobTypeId}>
                                        {option.JobTypeKey}
                                    </MenuItem>
                                ))}
                            </TextField>


                            <LocationAutocomplete
                                value={extraJobFields.location}
                                onChange={(val) => handleInputChange(val, "location")}
                                error={errors.location}
                            />


                            <Stack direction={"row"} spacing={2}>
                                <TextField
                                    label="Min Experience"
                                    value={extraJobFields.fromExperience ?? ''}

                                    onChange={(e) => {
                                        const value = e.target.value;
                                        const regex = /^\d+(\.\d{0,1})?$/
                                        if (value === '' || regex.test(value)) {
                                            handleInputChange(value, "fromExperience");
                                        }
                                    }}

                                    size="small"
                                    sx={{ width: '20vw' }}
                                    required
                                    error={!!errors.fromExperience}
                                    helperText={errors.fromExperience}
                                    autoComplete='off'
                                />


                                <TextField
                                    label="Max Experience"
                                    value={extraJobFields.toExperience ?? ''}

                                    onChange={(e) => {
                                        const value = e.target.value;
                                        const regex = /^\d+(\.\d{0,1})?$/
                                        if (value === '' || regex.test(value)) {
                                            handleInputChange(value, "toExperience");
                                        }
                                    }}

                                    size="small"
                                    sx={{ width: '20vw' }}
                                    error={!!errors.toExperience}
                                    helperText={errors.toExperience}
                                    autoComplete='off'
                                />
                            </Stack>



                            <HiringFlowDropdown
                                selectedStages={hiringFlow}
                                setSelectedStages={setHiringFlow}
                                stages={stages}
                                setHiringFlowEditMode={setHiringFlowEditMode}
                                hiringFlowEditMode={hiringFlowEditMode}
                                showEditHiringFlow={showEditHiringFlow}
                                hirigFlowData={hirigFlowData}
                            />
                            <TextField
                                select
                                value={extraJobFields.priority}
                                onChange={(e) => handleInputChange(e.target.value, "priority")}
                                size="small"
                                fullWidth
                                label="Priority"
                                required
                                sx={{ width: '20vw' }}
                                error={!!errors.priority}
                                helperText={errors.priority}
                                autoComplete='off'
                            >
                                {jobPriorityDropdown.map((option) => (
                                    <MenuItem key={option.JobPriorityId} value={option.JobPriorityId}>
                                        <PriorityBadge badgeName={option.JobPriorityKey} />
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Box>
                    )}



                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        backgroundColor: theme.palette.primary.light,
                        borderBottomLeftRadius: '1vw',
                        borderBottomRightRadius: '1vw',
                        width: '100%',
                        px: 2,
                        py: 2
                        // mt: 2, // Add margin so form above doesn't collide
                    }}
                >
                    {/* <Grid container spacing={2} pb={1.5} alignItems="center"> */}
                    {/* <Grid item xs={5.8} p="0 0.35vw 0 0.2vw">
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={internalJob}
                                        onChange={() => setInternalJob((prev) => !prev)}
                                        sx={{
                                            '& .MuiSwitch-switchBase.Mui-checked': {
                                                color: '#7F56D9',
                                                '&:hover': {
                                                    backgroundColor: '#7F56D9',
                                                },
                                            },
                                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                backgroundColor: '#7F56D9',
                                            },
                                        }}
                                    />
                                }
                                label="Internal Job Posting"
                            />
                        </Grid> */}

                    {/* <Grid item xs={6} style={{ textAlign: 'right' }}> */}
                    <Button variant="outlined" sx={{ marginRight: '0.83vw' }} onClick={handleJobListing}>
                        Exit
                    </Button>

                    {currentStep === 2 && (
                        <Button
                            variant="outlined"
                            sx={{ marginRight: '0.83vw' }}
                            onClick={() => setCurrentStep(1)}
                        >
                            Back
                        </Button>
                    )}

                    {currentStep === 1 ? (
                        <Button
                            variant="contained"
                            onClick={handleNext}
                            sx={{ marginRight: '0.2vw' }}
                            disabled={disableSaveJoblisting}
                        >
                            {'Next'}<FontAwesomeIcon style={{ marginLeft: '0.4vw' }} icon={faArrowRight} />
                        </Button>
                    ) : (
                        <Button
                            variant="contained"
                            onClick={handleSaveJob}
                            sx={{ marginRight: '0.2vw' }}
                            disabled={disableSaveJoblisting || hiringFlowEditMode}
                        >
                            {'Publish'}<FontAwesomeIcon style={{ marginLeft: '0.4vw' }} icon={faArrowRight} />
                        </Button>
                    )}
                    {/* </Grid> */}
                    {/* </Grid> */}
                </Box>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', margin: '1.25vw' }}>
                <Typography variant="h5">Custom Fields</Typography>
                <Button
                    variant="contained"
                    sx={{ position: 'relative', right: '-1.042vw' }}
                    onClick={handleAddMoreField}
                >
                    Add Custom Fields
                </Button>
            </Box>
            {errors.customfields && (
                <Box>
                    <Typography variant='subtitle1' color='error' textAlign='center'>{errors.customfields}</Typography>
                </Box>
            )}
            {showNewFieldContainer && newFieldsData.length > 0 && (
                <TableContainer component={Paper} >
                    <Table>
                        <TableHead >
                            <TableRow  >
                                <TableCell sx={{ padding: '1.11vw', font: theme.typography.caption }}>
                                    Fields
                                </TableCell >
                                <TableCell sx={{ padding: '1.11vw', font: theme.typography.caption }}>
                                    Values
                                </TableCell>
                                <TableCell sx={{ padding: '1.11vw 0vw 1.11vw 2.78vw', textAlign: 'center', font: theme.typography.caption }}>
                                    Actions
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {newFieldsData.map((data) => (
                                <CustomFields
                                    key={data.fieldKey}
                                    fieldKey={data.fieldKey}
                                    fieldData={data}
                                    onFieldDataUpdate={onFieldDataUpdate}
                                    onDeleteField={onDeleteField}
                                    existingFields={newFieldsData.map((field) => field.fieldName)} // Pass all field names as existingFields
                                    setDisableSaveJoblisting={setDisableSaveJoblisting}
                                />
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}

            <Backdrop
                sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
                open={isEkoOpen} // ✅ renamed to avoid conflict
            />

            <EkoAssistDialog
                open={isEkoOpen}
                onClose={handleClose}
                setJobDescription={setJobDescription}
            />


            <Dialog
                open={deleteDialogOpen}
                onClose={() => { setDeleteDialogOpen(false) }}
            >
                <DialogTitle>Confirm Delete</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete this logo? This action cannot be undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { setDeleteDialogOpen(false) }} sx={{ color: theme.palette.text.secondary }}>
                        Cancel
                    </Button>
                    <Button onClick={confirmDeleteLogo} variant="contained"
                        sx={{
                            bgcolor: theme.palette.error.main,
                            '&:hover': {
                                bgcolor: theme.palette.error.dark,
                            },
                        }}>
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default CreateJob;
